// extracted by mini-css-extract-plugin
module.exports = {"buttonCustomSettings":"styles_buttonCustomSettings__1ASia","buttonTextCustomSwitch":"styles_buttonTextCustomSwitch__2jIc3","iconButtonRoot":"styles_iconButtonRoot__3Hg80"};